import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '@/contexts/LanguageContext';
import { ArrowDown, ChevronRight } from 'lucide-react';

export default function HeroSection() {
  const { t, isRTL } = useLanguage();

  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1920&q=80')` }} />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B1120] via-[#0B1120]/70 to-black/40" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24 w-full">
        <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }} className="max-w-3xl">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3, duration: 0.8 }} className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] font-bold mb-6 font-['Outfit']">
            {t('hero.location')}
          </motion.p>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-light text-[#F8FAFC] font-['Cormorant_Garamond'] tracking-tighter leading-none mb-6">
            {t('hero.title1')}
            <span className="block text-[#D4AF37]">{t('hero.title2')}</span>
          </h1>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.6, duration: 0.8 }} className="text-lg md:text-xl text-[#94A3B8] font-['Outfit'] font-light max-w-xl mb-10 leading-relaxed">
            {t('hero.subtitle')}
          </motion.p>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.9, duration: 0.6 }} className="flex flex-wrap gap-4">
            <a href="#spaces" data-testid="hero-explore-btn" className="inline-flex items-center gap-2 bg-[#D4AF37] text-[#020617] font-medium px-8 py-4 hover:bg-[#FCE69C] transition-all duration-300 font-['Outfit'] text-sm tracking-wide">
              {t('hero.explore')} <ChevronRight className={`w-4 h-4 ${isRTL ? 'rotate-180' : ''}`} />
            </a>
            <a href="#contact" data-testid="hero-contact-btn" className="inline-flex items-center gap-2 bg-transparent text-white border border-white/20 px-8 py-4 hover:border-white hover:bg-white/5 transition-all duration-300 font-['Outfit'] text-sm tracking-wide">
              {t('hero.contactNow')}
            </a>
          </motion.div>
        </motion.div>
      </div>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.5, duration: 1 }} className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <motion.div animate={{ y: [0, 8, 0] }} transition={{ repeat: Infinity, duration: 2 }}>
          <ArrowDown className="w-5 h-5 text-[#94A3B8]" />
        </motion.div>
      </motion.div>
    </section>
  );
}
